import type { MetaFunction } from "react-router";

import { INDEX_ROBOTS_DIRECTIVE } from "~/constants/robots";
import { ROUTES } from "~/constants/routing";
import { DASHBOARD_HEADINGS } from "~/feature/dashboard/dashboardHeadings";
import { DashboardPage } from "~/feature/dashboard/pages/DashboardPage";
import { buildDashboardListingMetaJsonLd } from "~/jsonLD/aggregatedEventsFeed";
import {
  type DashboardEventsLoaderData,
  loadInitialAggregatedEvents,
} from "~/loaders/dashboardEvents";
import { EventTagEnum } from "~/types/tag";
import { generateMetaData } from "~/utils/generateMetaData";

import type { Route } from "./+types/endingSoon";

const { h1, subtitle } = DASHBOARD_HEADINGS[ROUTES.endingSoon.path];

export async function loader(): Promise<DashboardEventsLoaderData> {
  return {
    initialEvents: await loadInitialAggregatedEvents({
      tab: EventTagEnum.ENDING_SOON,
    }),
  };
}

export function clientLoader(): DashboardEventsLoaderData {
  return { initialEvents: null };
}

export const meta: MetaFunction = (metaArgs) => {
  return generateMetaData({
    seoData: { seoTitle: h1, seoDescription: subtitle },
    metaArgs,
    robotsDirective: INDEX_ROBOTS_DIRECTIVE,
    jsonLd: buildDashboardListingMetaJsonLd({
      metaArgs,
      routePath: ROUTES.endingSoon.path,
    }),
  });
};

export default function EndingSoon({ loaderData }: Route.ComponentProps) {
  return (
    <DashboardPage
      tab={EventTagEnum.ENDING_SOON}
      initialEvents={loaderData.initialEvents}
    />
  );
}
